import { ToastrService } from "ngx-toastr";

import { TradeClosedNotificationParams, TradeClosedNotificationComponent } from "./trade-closed-notification.component";
import { MobileTradeClosedNotificationComponent } from "../mobile-trade-closed-notification/mobile-trade-closed-notification.component";

export function ShowTradeClosedNotification(toastr: ToastrService, params: TradeClosedNotificationParams, mobileMode: string = 'desktop')
{
    const mobile = mobileMode != 'desktop';
    let config = Object.assign(toastr.toastrConfig, {});
    config.timeOut = 6000;
    config.closeButton = true;
    config.toastComponent = mobile? MobileTradeClosedNotificationComponent: TradeClosedNotificationComponent;
    return toastr.show(JSON.stringify(params), '', config);
}
